import { Box, IconButton, Link, Typography } from "@mui/material";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  httpAPI_INQ004,
  httpAPI_INQ012,
  httpAPI_INQ014,
  httpAPI_INQ015,
  httpAPI_STA035,
  httpAPI_STA043,
} from "./api/request";
import { GlobalContext } from "../../context/globalContext";
import TkTitle from "../../components/atoms/TkTitle";
import LockIcon from "@mui/icons-material/Lock";
import "./_style.scss";
import { TkGetCode } from "../../utils/TkGetCode";
import { IAPI_INQ014_Request } from "../../type/apiType";
import {
  PapaMamaPlus,
  SexFlug,
  RetireFlowReason,
  YesOrNoFlug,
  PaymentStatus,
  InquiryCode,
  TransferHistoryReason,
} from "../../assets/data/Constants";
import TkButton from "../../components/atoms/TkButton";
import TkBackButton from "../../components/molecules/TkBackButton";
import { BusinessContext } from "../../context/businessContext";
import { changeAmountFormat } from "../../utils/useTools";
import {
  childcareLeaveHeader,
  commentHeader,
  demanderKbnList,
  inquiryList,
  monthMapping,
  periodsHeaer,
  retireInfoList,
  transferHistoryHeader,
  unrecognizedMonthHeader,
} from "./parts";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import { IAPI_INQ004_Response } from "../../type/apiType";
import TkSearchFormItem from "../../components/atoms/TkSearchFormItem";
import { ProcedureModal, TkInquiryTable } from "./components/components";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkTable from "../../components/atoms/TkTable";
import TkTextArea from "../../components/molecules/TkTextArea";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import _ from "lodash";

/**
 * SCRW120005 職員照会
 * @return SCRW120005 職員照会
 */
const SCRW120005 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [stateInquiryList, setStateInquiryList] = useState(
    _.cloneDeep(inquiryList)
  );
  const [periodInfoList, setPeriodInfoList] = useState<any>([]);
  const [stateUnrecognizedMonthList, setStateUnrecognizedMonth] = useState<any>(
    []
  );
  const [childcareLeaveList, setChildcareLeaveList] = useState<any>([]);
  const [transferHistoryList, setTransferHistoryList] = useState<any>([]);
  const [stateRetireInfoList, setStateRetireInfoList] = useState(
    _.cloneDeep(retireInfoList)
  );
  const [resInit, setResInit] = useState<IAPI_INQ004_Response>({});
  const apiRes = useRef<any>();
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [selectPullDown, setSelectPullDown] = useState<string>();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [httpReq, setHttpReq] = useState<any>({});

  const selectValue = (e: any) => {
    const selectedLabel = demanderKbnList.find(
      (item) => item.value === e
    )?.value;
    setSelectPullDown(selectedLabel);
    apiRes.current = selectedLabel;
  };

  const demanderBtn = (contractorNo: any, staffNo: any) => {
    if (
      apiRes.current === "1" ||
      apiRes.current === "2" ||
      apiRes.current === "3"
    ) {
      setDialogOpen(true);
    }
    if (apiRes.current === "4") {
      resSTA035(contractorNo, staffNo);
    }
    if (apiRes.current === "5") {
      resSTA043(contractorNo, staffNo);
    }
  };

  const resSTA035 = async (contractorNo: any, staffNo: any) => {
    try {
      const res = await httpAPI_STA035({
        contractorNo: contractorNo,
        staffNo: staffNo,
      });
      if (res.resultCd === "I0000") {
        navigate("/SCRW110001");
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const resSTA043 = async (contractorNo: any, staffNo: any) => {
    try {
      const res = await httpAPI_STA043({
        contractorNo: contractorNo,
        staffNo: staffNo,
      });
      if (res.resultCd === "I0000") {
        navigate("/SCRW110001");
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 現在日付
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  // 数値変換
  function formatNumberToMoney(num: any) {
    if (typeof num !== "number") {
      return "";
    }
    return changeAmountFormat(num) + "円";
  }

  useEffect(() => {
    openingScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function openingScreen() {
    try {
      const res = await httpAPI_INQ004({
        contractorNo:
          location.state?.contractorNo ?? businessState.job_114?.contractorNo,
        staffNo: location.state?.staffNo ?? businessState.job_114?.staffNo,
      });

      if (res.resultCd === "I0000") {
        setResInit(res);

        let inquiryList = [...stateInquiryList];
        for (let i in res) {
          inquiryList.forEach((item) => {
            let targetObj = item.find((v) => v.keyword === i)!;

            if (targetObj) {
              if (i === "corpName") {
                targetObj.onClick = () => contractorNameLink(res);
              }
              if (i === "contractorNo" || i === "corpName") {
                if (res.systemAvailability === "0") {
                  targetObj.color = "#E1E8BE";
                } else {
                  targetObj.color = "";
                }
              }
              if (i === "facilityName") {
                targetObj.onClick = () => facilityNameLink(res);
              }
              if (i === "facilityNo" || i === "facilityName") {
                if (res.name2 === "社会福祉施設等") {
                  targetObj.color = "#e8c5be";
                } else {
                  targetObj.color = "";
                }
              }
              if (i === "status") {
                if (
                  res.status === "退職予定" ||
                  res.status === "退職（合算）" ||
                  res.status === "退職（支給）" ||
                  res.status === "契約対象外"
                ) {
                  targetObj.color = "#d8b9dd";
                } else if (
                  res.status === "解除（廃籍）" ||
                  res.status === "加入取消"
                ) {
                  targetObj.color = "#8a8a8a";
                } else {
                  targetObj.color = "";
                }
              }
              if (
                i === "staffNo" ||
                i === "staffNameKana" ||
                i === "staffNameKanji"
              ) {
                if (res.transitionalMeasuresFlg === "有") {
                  targetObj.color = "#e8c5be";
                } else {
                  targetObj.color = "";
                }
              }
              if (
                i === "staffNameKanji" &&
                res.retirementFormSubmittedFlg === "0"
              ) {
                targetObj.type = "link";
                targetObj.onClick = () => staffNameKanjiLink(res);
              }
              if (i === "staffNo") {
                targetObj.icon = (
                  <IconButton
                    onClick={() =>
                      handleSubmit(
                        res.contractorNo,
                        res.staffNo,
                        res.reserveFlg === "1" ? "0" : "1"
                      )
                    }
                  >
                    {res.reserveFlg === "1" ? (
                      <LockIcon data-testid="lockIcon" />
                    ) : (
                      <LockOpenIcon data-testid="lockOpenIcon" />
                    )}
                  </IconButton>
                );
              }

              targetObj.text = res[i as keyof typeof res];

              if (i === "sex") {
                targetObj.text = TkGetCode(SexFlug, res.sex);
              }
              if (i === "bNameKanji") {
                targetObj.text = res?.bNameKanji
                  ? res?.bNameKanji.split("　")[0]
                  : "";
              }
              if (i === "bNameKana") {
                targetObj.text = res?.bNameKana
                  ? res?.bNameKana.split(" ")[0]
                  : "";
              }
            }
          });
        }
        inquiryList.forEach((item) => {
          let salaryTableAmt = item.find(
            (i) => i.keyword === "salaryTableAmt"
          )!;
          let salaryAdjustmentAmt = item.find(
            (i) => i.keyword === "salaryAdjustmentAmt"
          )!;
          let total = item.find((i) => i.keyword === "total")!;
          if (salaryTableAmt) {
            salaryTableAmt.text = (
              <>
                {res.salaryList
                  ?.filter(
                    (salary) =>
                      salary.fiscalYear !== undefined &&
                      salary.fiscalYear !== null
                  )
                  .slice(0, 5)
                  .map((salary, index) => (
                    <React.Fragment key={index}>
                      {salary.salaryTableAmt !== undefined &&
                        salary.salaryTableAmt !== null && (
                          <Typography>
                            {index !== 0 && "　/　"}
                            {`${salary.fiscalYear}年：${formatNumberToMoney(
                              salary.salaryTableAmt
                            )}`}
                          </Typography>
                        )}
                    </React.Fragment>
                  ))}
              </>
            );
          }
          if (salaryAdjustmentAmt) {
            salaryAdjustmentAmt.text = (
              <>
                {res.salaryList?.slice(0, 5).map((salary, index) => (
                  <React.Fragment key={index}>
                    {salary.salaryAdjustmentAmt !== undefined &&
                      salary.salaryAdjustmentAmt !== null && (
                        <Typography>
                          {index !== 0 && "　/　"}
                          {`${salary.fiscalYear}年：${formatNumberToMoney(
                            salary.salaryAdjustmentAmt
                          )}`}
                        </Typography>
                      )}
                  </React.Fragment>
                ))}
              </>
            );
          }
          if (total) {
            total.text = (
              <>
                {res.salaryList?.slice(0, 5).map((salary, index) => (
                  <React.Fragment key={index}>
                    {salary.totalAmt !== undefined &&
                      salary.totalAmt !== null && (
                        <Typography>
                          {index !== 0 && "　/　"}
                          {`${salary.fiscalYear}年：${formatNumberToMoney(
                            salary.totalAmt
                          )}`}
                        </Typography>
                      )}
                  </React.Fragment>
                ))}
              </>
            );
          }
        });
        setStateInquiryList([...inquiryList]);

        // 各種期間に係る情報
        const periodInfo = [
          [
            {
              children: `(${res.calculationReferenceDateYear ?? 0}年${
                res.calculationReferenceDateMonth ?? 0
              }月時点)
              　在籍期間：${res.premiumEnrollYear ?? 0}年${
                res.premiumEnrollMonth ?? 0
              }か月
              　契約対象期間：${res.premiumContractPeriodYear ?? 0}年${
                res.premiumContractPeriodMonth ?? 0
              }か月
              　不算入月累計期間：${res.premiumUnaccountedMonths ?? 0}か月
              　被共済職員期間：${res.premiumMaePeriodYear ?? 0}年${
                res.premiumMaePeriodMonth ?? 0
              }か月`,
            },
          ],
        ];
        setPeriodInfoList(periodInfo);

        // ならない月情報
        let unrecognizedMonthList = [];
        res.unrecognizedMonthList?.forEach((item) => {
          let monthList = [
            {
              children: `${item.year}年度`,
            },
            {
              children: `${item.unrecognizedMonthNum}か月`,
            },
            {
              children: (
                <Box>
                  {Object.keys(monthMapping).map((monthKey, monthIndex) => {
                    const month = monthMapping[monthKey];
                    const isChecked =
                      item[monthKey as keyof typeof item] === "1";
                    return (
                      <TkCheckbox
                        key={monthIndex}
                        label={`${month} 月`}
                        checked={isChecked}
                        disabled={true}
                      />
                    );
                  })}
                </Box>
              ),
            },
          ];
          unrecognizedMonthList.push(monthList);
        });
        if (
          res.unrecognizedMonthNumBefore2000 &&
          res.unrecognizedMonthNumBefore2000 > 0
        ) {
          let unrecognizedMonthBefore2000 = [
            { children: "2000年度以前" },
            {
              children: `${res.unrecognizedMonthNumBefore2000}か月`,
            },
            { children: <></> },
          ];
          unrecognizedMonthList.push(unrecognizedMonthBefore2000);
        }
        setStateUnrecognizedMonth(unrecognizedMonthList);

        // 育児休業
        const childcareLeaveList = res.childcareLeaveList?.map((item) => [
          {
            children: item.birthday,
            align: "center",
          },
          {
            children: item.startDate,
            align: "center",
          },
          {
            children: item.endDate,
            align: "center",
          },
          {
            children: item.childcareLeaveMonthNum,
            align: "right",
          },
          {
            children: TkGetCode(PapaMamaPlus, item.papaMamaPlus),
            align: "center",
          },
          {
            children: item.halfyearExtendReason,
          },
          {
            children: TkGetCode(YesOrNoFlug, item.papaChildcareLeaveFlg),
            align: "center",
          },
        ]);
        setChildcareLeaveList(childcareLeaveList);

        // 異動履歴
        const transferHistoryList = res.transferHistoryList?.map((item) => [
          {
            children: TkGetCode(TransferHistoryReason, item.transferReason),
          },
          {
            children: item.transferDate,
            align: "center",
          },
          {
            children: item.aStaffNo,
          },
          {
            children: `${item.aContractorNo ?? ""}　${item.aCorpName ?? ""}`,
          },
          {
            children: `${item.aFacilityNo ?? ""}　${item.aFacilityName ?? ""}`,
          },
        ]);
        setTransferHistoryList(transferHistoryList);

        // 退職情報
        let retireInfoList = [...stateRetireInfoList];

        res.retireInfoList?.forEach((item) => {
          for (let i in item) {
            let targetObj = retireInfoList.find((item) => item.keyword === i)!;
            const retireDate = new Date(item.retireDate!);

            if (targetObj) {
              if (i === "retirementFormReceptionDate") {
                targetObj.node =
                  retireDate > today ? (
                    <>{item.retirementFormReceptionDate}</>
                  ) : (
                    <Link onClick={() => retirementFormReceptionDateLink(res)}>
                      {item.retirementFormReceptionDate}
                    </Link>
                  );
                continue;
              }
              if (i === "retireProcedureReason") {
                targetObj.text = TkGetCode(
                  RetireFlowReason,
                  item.retireProcedureReason
                );
                continue;
              }
              if (i === "taxFlg") {
                targetObj.text = TkGetCode(YesOrNoFlug, item.taxFlg);
                continue;
              }
              if (i === "retirementInvoiceReceptionSate") {
                // 現在日付
                targetObj.node =
                  retireDate > today ||
                  item.retirementAllowanceInvoiceViewFlg === "1" ? (
                    <>{item.retirementInvoiceReceptionSate}</>
                  ) : (
                    <Link
                      onClick={() => retirementInvoiceReceptionSateLink(res)}
                    >
                      {item.retirementInvoiceReceptionSate}
                    </Link>
                  );
                continue;
              }
              if (i === "paymenStatus") {
                targetObj.text = TkGetCode(PaymentStatus, item.paymenStatus);
                continue;
              }
              if (i === "paymentMultiplierId") {
                targetObj.text = item.paymentMultiplierId
                  ? `
                      ${item.paymentMultiplierId} (退職金額
                      ${formatNumberToMoney(
                        item.retirementAllowanceAmt ?? 0
                      )}、被共済期間
                      ${item.maePeriodYear ?? 0}年)
                    `
                  : "";
                continue;
              }
              if (i === "tmPaymentMultiplier") {
                targetObj.text = item.tmPaymentMultiplier
                  ? `
                      ${item.tmPaymentMultiplier} (退職金額
                      ${formatNumberToMoney(
                        item.tmRetirementAllowanceAmt ?? 0
                      )}、被共済期間
                      ${item.tmContractPeriodYear ?? 0}年)
                    `
                  : "";
                continue;
              }
              if (i === "registrationOfRemittanceAccount") {
                targetObj.node =
                  item?.registrationOfRemittanceAccount !== "無" ? (
                    <Link
                      onClick={() => registrationOfRemittanceAccountLink(res)}
                    >
                      {item.registrationOfRemittanceAccount}
                    </Link>
                  ) : (
                    <>{item.registrationOfRemittanceAccount}</>
                  );
                continue;
              }
              if (i === "addPaymentApplyFlg") {
                targetObj.node =
                  item?.addPaymentApplyFlg !== "無" ? (
                    <Link onClick={() => addPaymentApplyFlgLink(res)}>
                      {item.addPaymentApplyFlg}
                    </Link>
                  ) : (
                    <>{item.addPaymentApplyFlg}</>
                  );
                continue;
              }
              if (targetObj.id === "amt") {
                targetObj.text = formatNumberToMoney(
                  item[i as keyof typeof item] ?? 0
                );
                continue;
              }

              targetObj.text = item[i as keyof typeof item];
            }
          }

          retireInfoList.find((item) => item.keyword === "retireReason")!.text =
            item.fRetireReason
              ? `${item.nRetireReason ?? ""} →
             ${item.fRetireReason}
             ${res.createDate ? "（" + res.createDate + "）" : ""}`
              : item.nRetireReason ?? "";
        });
        setStateRetireInfoList([...retireInfoList]);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  }

  const handleSubmit = async (
    contractorNo: any,
    staffNo: any,
    reserveFlg: any
  ) => {
    setHttpReq({ ...makeHttpObj(contractorNo, staffNo, reserveFlg) });
    setIsOpenDialog(true);
  };

  const makeHttpObj = (
    contractorNo: any,
    staffNo: any,
    reserveFlg: any
  ): IAPI_INQ014_Request => {
    let reqObj: IAPI_INQ014_Request = {
      contractorNo: contractorNo,
      staffNo: staffNo, // 法人職員番号
      reserveFlg: reserveFlg,
    };
    return reqObj;
  };

  const contractorNameLink = (res: IAPI_INQ004_Response) => {
    setBusinessState({
      ...businessState,
      job_114: {
        ...businessState.job_114,
        contractorNo: res.contractorNo,
      },
    });
    navigate("/SCRC040101");
  };

  const facilityNameLink = (res: IAPI_INQ004_Response) => {
    setBusinessState({
      ...businessState,
      job_114: {
        ...businessState.job_114,
        contractorNo: res.contractorNo,
        facilityNo: res.facilityNo,
      },
    });
    navigate("/SCRW120004");
  };

  const staffNameKanjiLink = (res: IAPI_INQ004_Response) => {
    setBusinessState({
      ...businessState,
      job_114: {
        ...businessState.job_114,
        contractorNo: res.contractorNo,
      },
    });
    navigate("/SCRC080105", {
      state: {
        staffNo: res.staffNo,
        contractorName: res.corpName,
      },
    });
  };

  const retirementFormReceptionDateLink = (res: IAPI_INQ004_Response) => {
    navigate("/SCRW060004", {
      state: {
        contractorNo: res.contractorNo,
        contractorName: res.corpName,
        staffNo: res.staffNo,
        applyId: res.retirementFormApplyId,
      },
    });
  };

  const resINQ014 = async () => {
    try {
      const res = await httpAPI_INQ014({
        ...httpReq,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        openingScreen();
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    } finally {
      setIsOpenDialog(false);
    }
  };

  // 再送金口座登録有無 リンク 押下
  const registrationOfRemittanceAccountLink = (res: IAPI_INQ004_Response) => {
    setBusinessState({
      ...businessState,
      common: {
        contractorNo: res.contractorNo,
        contractorName: res.corpName,
      },
    });
    navigate("/SCRW410006", {
      state: {
        contractorNo: res.contractorNo,
        staffNo: res.staffNo,
        applyId: res.retirementAllowancePaymentBankChangeApplyId,
      },
    });
  };

  // 請求書受付日 リンク 押下
  const retirementInvoiceReceptionSateLink = (res: IAPI_INQ004_Response) => {
    setBusinessState({
      ...businessState,
      common: {
        contractorNo: res.contractorNo,
        contractorName: res.corpName,
      },
    });
    navigate("/SCRW410001", {
      state: {
        contractorNo: res.contractorNo,
        staffNo: res.staffNo,
        applyId: res.retirementAllowanceInvoiceApplyId,
      },
    });
  };

  const addPaymentApplyFlgLink = (res: IAPI_INQ004_Response) => {
    navigate("/SCRW070004", {
      state: {
        contractorNo: res.contractorNo,
        staffNo: res.staffNo,
        applyId: res.addPaymentApplyId,
      },
    });
  };

  const corpList = () => {
    setBusinessState({
      ...businessState,
      job_114: {
        ...businessState.job_114,
        contractorNo: resInit.contractorNo,
        facilityNo: resInit.facilityNo,
      },
    });
    navigate("/SCRW120004");
  };

  const staffList = () => {
    setBusinessState({
      ...businessState,
      job_114: {
        ...businessState.job_114,
        contractorNo: resInit.contractorNo,
      },
    });
    navigate("/SCRC040101");
  };

  const formatPhoneNumber = (phoneNumber: string) => {
    if (phoneNumber.length === 10) {
      return `${phoneNumber.slice(0, 4)}-${phoneNumber.slice(
        4,
        6
      )}-${phoneNumber.slice(6)}`;
    }
    return phoneNumber;
  };

  const onOkey = async (data: any) => {
    let jobCode = "";

    if (selectPullDown === "1") {
      jobCode = "JOB-78";
    } else if (selectPullDown === "2") {
      jobCode = "JOB-74";
    } else if (selectPullDown === "3") {
      jobCode = "JOB-48";
    }

    if (
      selectPullDown === "1" ||
      selectPullDown === "2" ||
      selectPullDown === "3"
    ) {
      try {
        const res = await httpAPI_INQ012({
          contractorNo: resInit.contractorNo,
          staffNo: resInit.staffNo,
          businessType: jobCode,
          screenId: "SCRW120005",
          ...data,
          demanderTel: formatPhoneNumber(data.demanderTel),
        });
        if (res.resultCd === "I0000") {
          navigate("/SCRW110001");
        } else {
          setDialogOpen(false);
          setState({ ...state, errorMsgId: res.resultCd });
        }
      } catch (error) {
        navigate("/error");
      }
    }
  };

  const handleUpdateClick = () => {
    // eslint-disable-next-line no-control-regex
    if (!comment.match(/^([^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ])*$/)) return;

    setOpen(true);
  };

  const handleCommentUpdate = async () => {
    // 照会用コメント更新API 呼び出し
    try {
      const res = await httpAPI_INQ015({
        contractorNo: resInit.contractorNo,
        staffNo: resInit.staffNo,
        inquiryCode: InquiryCode["職員"],
        refComment: comment,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    } finally {
      setOpen(false);
    }
  };

  return (
    <Box data-testid="SCRW120005PageForTest" className="tkSCRW120005">
      <Box className="tkTitleCenter">
        <TkTitle children={"職員照会"} size="large" />
      </Box>

      <Box className="demanderRegistrationGroup">
        <Box component="span">請求者登録：</Box>
        <TkSearchFormItem
          getChangeValue={selectValue}
          label=""
          type="selectFrom"
          selectPropsList={demanderKbnList}
        />
        <TkButton
          onClick={() => demanderBtn(resInit.contractorNo, resInit.staffNo)}
        >
          登録
        </TkButton>
      </Box>

      <TkInquiryTable list={stateInquiryList} />

      <Box className="comments">
        <Box className="tkLineTitle">{"追記情報"}</Box>
        <TkTable
          headList={commentHeader}
          bodyList={[
            [
              {
                children: (
                  <TkTextArea
                    onlyFullWidth
                    inputProps={{ maxLength: 2000 }}
                    wantToSetValue={resInit.refComment}
                    onChange={(e: any) => setComment(e.target.value)}
                  />
                ),
              },
            ],
          ]}
        />
        <Box className="button">
          <TkButton onClick={handleUpdateClick}>コメント更新</TkButton>
        </Box>
      </Box>

      <Box className="tkLineTitle">{"各種期間に係る情報"}</Box>
      <TkTable headList={periodsHeaer} bodyList={periodInfoList} />

      <Box className="tkLineTitle">{"ならない月情報"}</Box>
      <TkTable
        headList={unrecognizedMonthHeader}
        bodyList={stateUnrecognizedMonthList}
      />

      <Box className="tkLineTitle">{"育児休業"}</Box>
      <TkTable headList={childcareLeaveHeader} bodyList={childcareLeaveList} />

      <Box className="tkLineTitle">{"異動履歴"}</Box>
      <TkTable
        headList={transferHistoryHeader}
        bodyList={transferHistoryList}
      />

      <Box className="tkLineTitle">{"退職情報"}</Box>
      <TkFakeTable
        list={stateRetireInfoList}
        ruleSchema={{}}
        showButton={false}
      />

      <Box className="tkBtnArea">
        <TkBackButton />
        <TkButton onClick={staffList}>{"契約者情報"}</TkButton>
        <TkButton onClick={corpList} disabled={!resInit.facilityNo}>
          {"施設情報"}
        </TkButton>
      </Box>
      <ProcedureModal
        open={dialogOpen}
        onOkey={onOkey}
        onClose={() => setDialogOpen(false)}
      />
      <TkMessageDialog
        open={isOpenDialog}
        okText="はい"
        cancelText="いいえ"
        title="確認"
        contextText="　留保フラグの更新を行いますが、問題ないでしょうか。"
        onOky={resINQ014}
        onCancel={() => setIsOpenDialog(false)}
      />
      <TkMessageDialog
        open={open}
        onOky={handleCommentUpdate}
        onCancel={() => setOpen(false)}
        title="更新"
        contextText="　コメントを更新しますが、問題ないでしょうか。"
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRW120005;
